import React from 'react';

const projects = [
  { title: 'Banking Portal', client: 'Merrill Lynch', category: 'Web Development', icon: '🏦', desc: 'Enterprise banking portal with real-time data and secure transactions.' },
  { title: 'Healthcare Management', client: 'MetLife', category: 'Software Development', icon: '🏥', desc: 'Comprehensive healthcare management system with EMR integration.' },
  { title: 'E-Commerce Platform', client: 'Retail Client', category: 'Web Services', icon: '🛒', desc: 'Full-featured e-commerce platform with inventory and payment systems.' },
  { title: 'Mobile Banking App', client: 'JPMorgan Chase', category: 'Mobile Development', icon: '📱', desc: 'Secure mobile banking application for iOS and Android.' },
  { title: 'SEO Campaign', client: 'PepsiCo', category: 'Digital Marketing', icon: '📈', desc: 'Nationwide SEO and digital marketing campaign with 300% ROI.' },
  { title: 'Government Portal', client: 'Federal Agency', category: 'Government', icon: '🏛️', desc: 'Secure citizen services portal with FISMA compliance.' },
  { title: 'Telecom CRM', client: 'Verizon', category: 'Software Development', icon: '📡', desc: 'Custom CRM system for telecom customer management.' },
  { title: 'AI Analytics Dashboard', client: 'NYSE', category: 'AI Services', icon: '🧠', desc: 'AI-powered analytics dashboard for real-time market insights.' },
];

const Portfolio = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Our Portfolio</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Projects we're proud of</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {projects.map((p, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100 p-3">
                <div style={{ fontSize: 40 }} className="mb-3">{p.icon}</div>
                <span className="badge bg-primary bg-opacity-10 text-primary mb-2" style={{ fontSize: 11 }}>{p.category}</span>
                <h6 className="fw-bold">{p.title}</h6>
                <p className="text-muted small">{p.desc}</p>
                <div className="mt-auto small text-muted fw-semibold">Client: {p.client}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Portfolio;
